import { render } from "./LawInfo.vue?vue&type=template&id=0501296e"
import script from "./LawInfo.vue?vue&type=script&lang=js"
export * from "./LawInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__